import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  consumeAuthFromLocation,
  getAccessToken,
  SILENT_AUTH_MESSAGE_TYPE,
} from "../../utils/authToken";
import { consumeAuthReturnPath } from "../../utils/walkInBookingDraft";

const SilentAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = consumeAuthFromLocation(location.pathname, location.search);
    const token = auth.token || getAccessToken();
    const payload = {
      type: SILENT_AUTH_MESSAGE_TYPE,
      token: token || "",
      ok: Boolean(token),
    };

    if (window.parent && window.parent !== window) {
      window.parent.postMessage(payload, window.location.origin);
      return;
    }
    if (window.opener && window.opener !== window) {
      window.opener.postMessage(payload, window.location.origin);
      window.close();
      return;
    }

    const next = consumeAuthReturnPath("/admin-dashboard/walk-in-booking");
    navigate(next, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-stone-600 text-sm">
      Refreshing session…
    </div>
  );
};

export default SilentAuthCallback;
